import { getServices } from '../../../../../infra/commonInitializer';

export default function valueFunctionQueryParam(
  value: Record<string, any>
): boolean {
  const { URLService } = getServices() || {};

  const currentPathDescription = URLService.getCurrentPathDescription();

  return URLService.isSearchIncluded(value, currentPathDescription?.search);
}
